export enum FeatureEntitlements {
  Aioli = 'aioli',
}
